import React, {useState, useMemo, useEffect, useContext} from 'react'
import _ from 'lodash'

import {IconButton, Popover, Checkbox, Grid} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import './PopFieldToggle.scss'
import FilterFieldsList from './FilterFieldsList'
import FilterFieldItemsList from './FilterFieldItemsList'
import FilterSelectedValues from './FilterSelectedValues'
import {normalizeFieldValues} from './util'
import {ReservationContext} from '../../../context/Reservation'

const PopFieldToggle = ({
  options = [],
  open,
  value,
  onClickOption,
  onClose,
  anchorEl,
  objects,
  filters = null,
}) => {
  const {filterFieldValues} = useContext(ReservationContext)
  const [selectedFilters, setSelectedFilters] = useState([])
  const [selectedField, setSelectedField] = useState({})
  const handleClose = e => {
    if (onClose) {
      onClose(e, selectedFilters)
    }
    setSelectedField({})
  }

  useEffect(() => {
    if (open) {
      if (selectedFilters.length > 0 && _.isEmpty(selectedField)) {
        const t = selectedFilters[0]
        setSelectedField({
          field_id: t.id,
          key: t.key,
          field_name: t.field_name,
        })
      }
    }
  }, [selectedFilters, open, selectedField])

  useEffect(() => {
    if (open && !!filters) {
      setSelectedFilters(filters)
    }
  }, [filters, open])

  const handleApplyFilter = e => {
    if (onClose) {
      onClose(e, selectedFilters)
    }
    setSelectedField({})
  }

  const handleClickOption = (e, t) => {
    if (onClickOption) {
      onClickOption(e, t)
    }
    setSelectedField(t)
  }

  const checkFilterFieldExists = currentId => {
    let op = false
    selectedFilters.map(f => {
      if (f.id === currentId) {
        op = true
      }
      return true
    })
    return op
  }

  const updateSelectedFilters = (id, val, isAll = false) => {
    let _selectedFilters = selectedFilters.reduce((ret, sf) => {
      if (sf.id === id) {
        if (isAll) {
          let normalizedValues = normalizeFieldValues(
            filterFieldValues.data.field_type,
            filterFieldValues.data.values
          )
          let allValues = [{value: 'no_value'}, ...normalizedValues]
          console.log(allValues)
          sf.value = allValues.map(nv => {
            return nv.value
          })
        } else {
          // get index
          const _index = sf.value.indexOf(val)
          //  if exist
          if (_index !== -1) {
            sf.value.splice(_index, 1)
          } else {
            sf.value = [...sf.value, val]
          }
        }
      }
      if (sf.value.length > 0) {
        return [...ret, sf]
      }
      return ret
    }, [])
    setSelectedFilters(_selectedFilters)
  }

  const handleClickValueOption = (e, t) => {
    if (checkFilterFieldExists(selectedField.field_id)) {
      if (t === 'select_all') {
        updateSelectedFilters(selectedField.field_id, t, true)
      } else {
        updateSelectedFilters(selectedField.field_id, t)
      }
    } else {
      if (t === 'select_all') {
        let normalizedValues = normalizeFieldValues(
          filterFieldValues.data.field_type,
          filterFieldValues.data.values
        )
        let allValues = [{value: 'no_value'}, ...normalizedValues]
        setSelectedFilters([
          ...selectedFilters,
          {
            id: selectedField.field_id,
            key: selectedField.key,
            field_name: selectedField.field_name,
            value: allValues.map(nv => {
              return nv.value
            }),
          },
        ])
      } else {
        setSelectedFilters([
          ...selectedFilters,
          {
            id: selectedField.field_id,
            key: selectedField.key,
            field_name: selectedField.field_name,
            value: [t],
          },
        ])
      }
    }
  }

  const handleClickSelectedValueOption = (e, t) => {
    if (onClickOption) {
      onClickOption(e, t)
    }
    setSelectedField({
      field_id: t.id,
      key: t.key,
      field_name: t.field_name,
    })
  }

  const handleCloseValueOption = (e, t) => {
    let _selectedFilters = []
    selectedFilters.map(sf => {
      if (sf.id !== t.id) {
        _selectedFilters.push(sf)
      }
      return true
    })

    setSelectedFilters(_selectedFilters)
  }

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      classes={{
        paper: 'c-pop-field-toggle',
      }}
      keepMounted
    >
      <Grid container style={{height: 400}}>
        {!!selectedFilters.length && (
          <Grid item>
            <FilterSelectedValues
              options={options}
              handleClickSelectedValueOption={handleClickSelectedValueOption}
              handleCloseValueOption={handleCloseValueOption}
              value={selectedField}
              values={selectedFilters}
              handleApplyFilter={handleApplyFilter}
              setSelectedFilters={setSelectedFilters}
            />
          </Grid>
        )}
        <Grid item>
          <FilterFieldsList
            options={options}
            handleClickOption={handleClickOption}
            value={selectedField}
            values={selectedFilters}
            open={open}
          />
        </Grid>
        <Grid item>
          <FilterFieldItemsList
            options={options}
            field={selectedField}
            objects={objects}
            handleClickValueOption={handleClickValueOption}
            value={value}
            values={selectedFilters}
            setSelectedFilters={setSelectedFilters}
          />
        </Grid>
      </Grid>
    </Popover>
  )
}

export default PopFieldToggle
